// Health Marker Types

export enum HealthMarkerType {
  HEART_RATE = 'heart_rate',
  BLOOD_PRESSURE = 'blood_pressure',
  OXYGEN_SATURATION = 'oxygen_saturation',
  WEIGHT = 'weight',
  HEIGHT = 'height',
  TEMPERATURE = 'temperature',
  MEDICATION = 'medication',
  PROCEDURE = 'procedure',
}

export interface HealthMarker {
  id: number;
  patient_id: number;
  type: HealthMarkerType;
  value: string | number;
  unit?: string;
  recorded_at: string;
  created_at: string;
  updated_at: string;
}

export interface HealthMarkerData {
  patient_id: number;
  type: HealthMarkerType;
  value: string | number;
  unit?: string;
  recorded_at?: string;
}
